import React from 'react';
import { View } from 'react-native';
import { Image } from 'react-native-web';
import { textPrimary_16_0 } from '../TextComponent/TextStyle';
import { suggested_for_you_str } from '../../../../utils/DictionaryManagementUtils';
import { img_close_x } from '../../../../utils/ImagesManagementUtils';
import LongLine from '../MixComponent/LongLine';

//= ========================================================================

const TextWithIconLine = ({ globJSON }) => {
  const myStyles = {
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 6,
      paddingStart: 15,
    },
    img_close: {
      width: 24,
      height: 24,
    },
  };

  return (
    <View>
      <LongLine globJSON={globJSON} marginBottom={4} />
      <View style={myStyles.container}>
        <textPrimary_16_0 style={{ fontWeight: 'bold' }}>
          {suggested_for_you_str}
        </textPrimary_16_0>
        <Image
          fadeDuration={0}
          style={myStyles.img_close}
          source={img_close_x}
        />
      </View>
    </View>

  );
};
export default TextWithIconLine;
